import macOSLogo from "../../../pages/Connections/config/icons/apple-logo.svg";
import WindowsLogo from "../../../pages/Connections/config/icons/windows-logo.svg";
import LinuxLogo from "../../../pages/Connections/config/icons/linux-logo.svg";

export const instructions = {
  crowdstrike: "https://docs.actzero.ai/endpoints/crowdstrike/agent-prereqs/",
  defender: "https://docs.actzero.ai/mdfe/",
};

export const statsConfig = [
  { label: "Contracted", value: "contracted" },
  { label: "Installed", value: "installed" },
];

export const agentLogos = [
  { name: "windows", svg: WindowsLogo },
  { name: "mac", svg: macOSLogo },
  { name: "linux", svg: LinuxLogo, isModal: true },
];

export const MDRAppLinks = {
  defendifyAppLink: 'https://login.microsoftonline.com/organizations/v2.0/adminconsent?response_type=code&scope=35e8fe83-fd6c-4747-bcf4-ff46ea12e725%2F.default&resource=https%3A%2F%2Fmanage.office.com&client_id=35e8fe83-fd6c-4747-bcf4-ff46ea12e725',
  wgAppLink: 'https://login.microsoftonline.com/organizations/v2.0/adminconsent?response_type=code&scope=64360416-0824-4f61-8558-cd55d5998ef2%2F.default&resource=https%3A%2F%2Fmanage.office.com&client_id=64360416-0824-4f61-8558-cd55d5998ef2',
  nonWGAppLink: 'https://login.microsoftonline.com/organizations/v2.0/adminconsent?response_type=code&scope=9070802f-d159-462e-8dee-351c5db94179%2F.default&resource=https%3A%2F%2Fmanage.office.com&client_id=9070802f-d159-462e-8dee-351c5db94179'
}
